import SearchOffIcon from "@mui/icons-material/SearchOff";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function ProductEmptyState() {
  return (
    <Box
      data-testid="product-empty-state"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 10,
        gap: 2,
        color: "#9e9e9e",
      }}
    >
      <SearchOffIcon sx={{ fontSize: 48, color: "#d4c4b8" }} />
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 600,
          color: "#757575",
        }}
      >
        No products match your filters
      </Typography>
      <Typography
        sx={{
          fontSize: "14px",
          color: "#9e9e9e",
        }}
      >
        Try adjusting your filter selection to see more products.
      </Typography>
    </Box>
  );
}
